var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faChartSimple, faClockRotateLeft, faCoins } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LoadingButton } from '@mui/lab';
import { Box, Typography, styled } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import { Slide, toast } from 'react-toastify';
import { PlanTypeCategory, StatusPermission } from '../../enum';
import { ACTUAL_ROUTER_URL, REPORT_ROUTER_URL, ROUTER_URL } from '../../router/constants';
import { useUserPermissionsAPI } from '../app/selectors';
import { TerminologyProvider } from '../app/terminology';
import { ErrorMessageBox, ExitBar, Outlet, Tab, Tabs } from '../common';
import { SeatCapacityProvider } from '../seatCapacity';
import { useSimulatingInProgress } from '../toastify/selector';
import { ReportProvider, useReportContext } from './context';
import { useDisabledFinancial, useReportType, useSelectedTab } from './hooks';
import { ProgressToastContent } from './progressToastContent';
import { useDisplayModeParams, useExistMultiskillMode, useReportAPI } from './selectors';
var StyledTabsHeader = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
});
var StyledIcon = styled(FontAwesomeIcon)(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.palette.primary.main,
        '&.fa-clock-rotate-left': {
            '& path': {
                opacity: '1 !important',
            },
        },
    });
});
var ButtonGroups = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        gap: theme.spacing(3),
        marginBottom: theme.spacing(2),
    });
});
var ExitBarWrapper = function (_a) {
    var title = _a.title, planId = _a.planId;
    var _b = useReportContext(), isDirty = _b.isDirty, confirmExit = _b.confirmExit;
    var navigate = useNavigate();
    var handleBeforeExit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var ok;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isDirty || !confirmExit)
                        return [2 /*return*/];
                    e.preventDefault();
                    e.stopPropagation();
                    return [4 /*yield*/, confirmExit()];
                case 1:
                    ok = _a.sent();
                    if (ok) {
                        navigate(ROUTER_URL.Home);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx("div", __assign({ onClickCapture: handleBeforeExit }, { children: _jsx(ExitBar, { title: title, titleEntity: { kind: 'plan', id: planId } }) })));
};
export var useTabRoutes = function () {
    var _a, _b;
    var permission = useUserPermissionsAPI();
    var reportData = useReportAPI()[0];
    var isReady = !!reportData.data;
    var isDisableFinancial = useDisabledFinancial();
    var isProdHoursPlan = ((_a = reportData.data) === null || _a === void 0 ? void 0 : _a.planTypeCategory) === PlanTypeCategory.ProdHours;
    var isDisabledActual = !((_b = reportData.data) === null || _b === void 0 ? void 0 : _b.hasDaily) || isProdHoursPlan;
    var tabRoutes = useMemo(function () {
        var routers = [
            {
                path: REPORT_ROUTER_URL.Resourcing,
                title: 'resourcing.title',
                icon: faChartSimple,
            },
        ];
        if ((permission === null || permission === void 0 ? void 0 : permission.financialPermission) !== StatusPermission.Hide) {
            routers.push({
                path: REPORT_ROUTER_URL.Financial,
                title: 'financial.title',
                icon: faCoins,
                disabled: isDisableFinancial,
            });
        }
        if ((permission === null || permission === void 0 ? void 0 : permission.recruitmentPermission) !== StatusPermission.Hide) {
            routers.push({
                path: REPORT_ROUTER_URL.Training,
                title: 'trainingRecruitment.title',
                icon: 'users',
            });
        }
        if ((permission === null || permission === void 0 ? void 0 : permission.actualPermission) !== StatusPermission.Hide) {
            routers.push({
                path: REPORT_ROUTER_URL.Actual,
                title: 'actual.title',
                icon: faClockRotateLeft,
                disabled: isDisabledActual,
            });
        }
        return routers;
    }, [isDisableFinancial, isDisabledActual, permission]);
    return [tabRoutes, isReady];
};
var ReportTabs = function () {
    var _a;
    var t = useTranslation('report').t;
    var _b = useTabRoutes(), tabRoutes = _b[0], isReady = _b[1];
    var value = useSelectedTab();
    var displayMode = useDisplayModeParams()[0];
    var reportType = useReportType();
    var existMultiskillMode = useExistMultiskillMode();
    var navigate = useNavigate();
    var _c = useReportContext(), isDirty = _c.isDirty, confirmExit = _c.confirmExit;
    var handleTabClick = function (toRoute, e) { return __awaiter(void 0, void 0, void 0, function () {
        var ok;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(isDirty && confirmExit)) return [3 /*break*/, 2];
                    e.preventDefault();
                    return [4 /*yield*/, confirmExit()];
                case 1:
                    ok = _a.sent();
                    if (!ok)
                        return [2 /*return*/];
                    _a.label = 2;
                case 2:
                    navigate(toRoute);
                    return [2 /*return*/];
            }
        });
    }); };
    var disabled = ((_a = tabRoutes.find(function (route) { return route.path === value; })) !== null && _a !== void 0 ? _a : { disabled: true }).disabled;
    if (isReady && disabled)
        return _jsx(Navigate, { to: REPORT_ROUTER_URL.Resourcing, replace: true });
    return (_jsx(Tabs, __assign({ value: value }, { children: tabRoutes.map(function (route) {
            var toRoute = route.path;
            if (![REPORT_ROUTER_URL.Training, REPORT_ROUTER_URL.Actual].includes(route.path)) {
                if (reportType !== ACTUAL_ROUTER_URL.Settings)
                    toRoute += "/".concat(reportType);
                if (existMultiskillMode) {
                    var separator = toRoute.includes('?') ? '&' : '?';
                    toRoute += "".concat(separator, "displayMode=").concat(displayMode);
                }
            }
            return (_jsx(Tab, { component: Link, icon: _jsx(StyledIcon, { icon: route.icon, size: "lg" }), iconPosition: "start", value: route.path, to: toRoute, label: _jsxs(Typography, __assign({ variant: "subtitle2" }, { children: ["\u00A0", t(route.title)] })), disabled: route.disabled, "data-testid": route.title, onClick: function (e) { return handleTabClick(toRoute, e); } }, route.path));
        }) })));
};
export var ReportLayout = function () {
    var _a, _b, _c, _d;
    var t = useTranslation().t;
    var _e = useReportAPI(), reportData = _e[0], clearReportData = _e[2];
    var _f = useState(), onExport = _f[0], setOnExport = _f[1];
    var _g = useState(false), isLoadingExport = _g[0], setIsLoadingExport = _g[1];
    var _h = useState(false), isDisabledExport = _h[0], setIsDisabledExport = _h[1];
    var basePlanId = useParams().basePlanId;
    var isSimulating = !!((_a = useSimulatingInProgress(basePlanId)) === null || _a === void 0 ? void 0 : _a.length);
    useEffect(function () {
        return clearReportData;
    }, [clearReportData]);
    useEffect(function () {
        if (isSimulating) {
            var toastId_1 = toast.info(_jsx(ProgressToastContent, {}), {
                autoClose: false,
                position: 'bottom-right',
                theme: 'colored',
                closeButton: false,
                closeOnClick: false,
                transition: Slide,
                icon: false,
            });
            return function () { return toast.dismiss(toastId_1); };
        }
    }, [isSimulating, t, basePlanId]);
    return (
    /* Report terminology follows the plan's data source, same as the wizard */
    _jsx(TerminologyProvider, __assign({ value: (_b = reportData.data) === null || _b === void 0 ? void 0 : _b.importSource }, { children: _jsx(ReportProvider, { children: _jsxs(SeatCapacityProvider, { children: [_jsx(ErrorMessageBox, { errors: [reportData.error], sx: { margin: 3, marginBottom: 0 } }), _jsx(ExitBarWrapper, { title: (_c = reportData.data) === null || _c === void 0 ? void 0 : _c.name, planId: (_d = reportData.data) === null || _d === void 0 ? void 0 : _d.id }), _jsx(Box, __assign({ sx: { bgcolor: 'common.white', padding: '1rem 1.25rem 0' } }, { children: _jsxs(StyledTabsHeader, { children: [_jsx(ReportTabs, {}), _jsx(ButtonGroups, { children: _jsx(LoadingButton, __assign({ variant: "outlined", disabled: !onExport || isDisabledExport, onClick: function () { return onExport === null || onExport === void 0 ? void 0 : onExport(); }, loading: isLoadingExport }, { children: t('action.export') })) })] }) })), !reportData.error && _jsx(Outlet, { context: { setOnExport: setOnExport, setIsLoadingExport: setIsLoadingExport, setIsDisabledExport: setIsDisabledExport } })] }) }) })));
};
